import { isArray, isDefined } from "ionic-angular/util/util";
import { Field } from "../../vas/business-objects/field/field.model";
import { Control } from "../../vas/business-objects/control/control.model";

export class Model {

    constructor(protected object) {

    }

    getFieldValue(name: string, controls: Array<Control>, defaultValue?): any {

        if (!isDefined(this.object["fields"]) || !isArray(this.object["fields"])) {
            return defaultValue;
        }

        const control = controls.filter(c => c.name === name).pop();

        if (!isDefined(control)) {
            return defaultValue;
        }

        const fields: Array<Field> = this.object.fields;
        let field;

        try {
            field = fields.filter(f => f.control === control.id).pop();
        } catch (error) {
            // console.warn(`error during getFieldValue(${name})`, error);
        }

        if (!field) {
            return defaultValue;
        }

        return field.value;
    }

    get(attr, defaultValue?): any {
        let parts;

        const values = this.object;

        if (!values) {
            return defaultValue;
        }

        if (!attr) return;

        parts = attr.split(".");

        if (parts.length === 1) {
            if (typeof values[attr] === "undefined") {
                return defaultValue;
            }
            return values[attr];
        } else {
            return this._getValueByParts(parts, values, defaultValue);
        }
    }

    _getValueByParts(parts, attrs, defaultValue): any {
        let value;
        if (parts.length === 1) {
            if (typeof attrs[parts[0]] === "undefined") {
                return defaultValue;
            }
            return attrs[parts[0]];
        } else {
            value = attrs[parts[0]];

            if (typeof value === "undefined") {
                return defaultValue;
            }

            parts.splice(0, 1);
            return this._getValueByParts(parts, value, defaultValue);
        }
    }
}



// WEBPACK FOOTER //
// ./src/core/util/model.ts